import { render, staticRenderFns } from "./Forum.vue?vue&type=template&id=7169085c&"
import script from "./Forum.vue?vue&type=script&lang=js&"
export * from "./Forum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7169085c')) {
      api.createRecord('7169085c', component.options)
    } else {
      api.reload('7169085c', component.options)
    }
    module.hot.accept("./Forum.vue?vue&type=template&id=7169085c&", function () {
      api.rerender('7169085c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/Forum.vue"
export default component.exports